"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthContext = exports.AuthProvider = void 0;
const react_1 = __importStar(require("react"));
const useLocalStorage_1 = __importDefault(require("@/hooks/useLocalStorage"));
const msal_react_1 = require("@azure/msal-react");
const AuthStateContext = react_1.default.createContext(undefined);
function AuthProvider({ children }) {
    const { instance, accounts } = (0, msal_react_1.useMsal)();
    const [user, setUser] = (0, useLocalStorage_1.default)("AuthContext", null);
    (0, react_1.useEffect)(() => {
        const updateUserAndToken = async () => {
            if (accounts.length === 0) {
                return;
            }
            const account = accounts[0];
            try {
                const response = await instance.acquireTokenSilent({
                    scopes: ["User.Read"],
                    account: account,
                });
                setUser({
                    homeAccountId: account.homeAccountId,
                    name: account.name,
                    username: account.username,
                    accessToken: response.accessToken,
                    expiresOn: response.expiresOn || undefined,
                });
            }
            catch (error) {
                console.warn(error);
            }
        };
        updateUserAndToken();
    }, [accounts, instance, setUser]);
    return (react_1.default.createElement(AuthStateContext.Provider, { value: { user, setUser } }, children));
}
exports.AuthProvider = AuthProvider;
function useAuthContext() {
    const context = react_1.default.useContext(AuthStateContext);
    if (context === undefined)
        throw new Error("useAuthState must be used within a AuthProvider");
    return context;
}
exports.useAuthContext = useAuthContext;
